import { AnyAction } from "redux";
import { ThunkAction } from "redux-thunk";
import {
    DELIVERY_TYPE,
    DeliveryType,
    INVOICE_TYPE,
    PaymentMethod,
    API_URL_PAYMENT,
    API_URL_PAYMENT_TYPE,
} from "../../../../../constants";
import { RootState } from "../../../../../models";
import { AdyenPaymentDetails } from "../../../../../models/actionPayloads/createPurchaseRequest";
import * as Ajax from "../../../app/Ajax";
import * as generalActions from "../../../app/state/generalActions";
import TEXT from "../../text-consts";
import * as AT from "../actionTypes";

export const checkoutPayment =
    (
        type?: DeliveryType,
        code?: string,
        note?: string,
        selectedPaymentMethod?: PaymentMethod,
        selectedInvoiceDeliveryMethod = INVOICE_TYPE.EMAIL,
        adyenPaymentDetails?: AdyenPaymentDetails,
        hasSeenDelayOnPurchaseModal?: boolean,
    ): ThunkAction<any, RootState, unknown, AnyAction> =>
    (dispatch) => {
        // Validate delivery type
        if (type === DELIVERY_TYPE.PICK_UP_IN_SHOP && (!code || code === "dummy-shop")) {
            return dispatch(generalActions.setNegativeFlash(TEXT.ERROR.NO_SHOP_CHOSEN));
        } else if (type === DELIVERY_TYPE.PICK_UP_POINT && !code) {
            return dispatch(generalActions.setNegativeFlash(TEXT.ERROR.NO_PICK_UP_POINT_CHOSEN));
        }

        return dispatch({
            type: AT.CHECKOUT_PAYMENT,
            payload: Ajax.put(
                {
                    url: API_URL_PAYMENT,
                    data: {
                        type,
                        note,
                        paymentType: selectedPaymentMethod,
                        selectedInvoiceDeliveryMethod,
                        adyenPaymentDetails,
                        hasSeenDelayOnPurchaseModal,
                    },
                },
                dispatch,
            ),
            meta: {
                flashOnError: {
                    defaultErrorMessage: TEXT.ERROR.ORDER_SUBMIT + "ved betaling.",
                },
            },
        });
    };

export const setSelectedPaymentType =
    (paymentType: PaymentMethod): ThunkAction<void, RootState, unknown, AnyAction> =>
    (dispatch) =>
        dispatch({
            type: AT.CHECKOUT_SET_SELECTED_PAYMENT_TYPE,
            payload: Ajax.put(
                {
                    url: API_URL_PAYMENT_TYPE,
                    data: { paymentType },
                },
                dispatch,
            ),
        });

export const resetLeaseError = () => ({
    type: AT.CHECKOUT_RESET_LEASE_ERROR,
});

export const closeDelayOnPurchaseModal = () => ({
    type: AT.CHECKOUT_CLOSE_DELAY_ON_PURCHASE_MODAL,
});
